import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../fetchData";



export const useGetTrainerTerms = () => {
    return useQuery({
        queryKey: ["trainerUp/terms"],
        queryFn: () => fetchData("trainerUp/terms"),
    });
};


export const useGetAssesmentForTrainer = (courseId) => {
    return useQuery({
        queryKey: ["question-paper"],
        queryFn: () => fetchData(`question-paper/${courseId}`),

    });
};


